import useResource from "../../../hooks/UseResource";
import * as GrandPrixService from "../../../services/GrandPrixService";

export default function useCurrentGrandPrix() {
    return useResource("does not matter", GrandPrixService.getActiveGrandPrix);
}
